export default {
    company: {
        name: "Yibin Kağıt Endüstrisi (YKE)"
    },
    nav: {
        home: "Ana Sayfa",
        about: "Hakkımızda",
        products: "Ürünlerimiz",
        contact: "İletişim",
        sustainability: "Sürdürülebilirlik",
        technology: "Teknolojik İnovasyon"
    },
    banner: {
        title: "Bambunun Zarif Dokunuşu · Yeşil Yarınlar",
        subtitle: "Binyıllık Kağıt Sanatını Yaşatıyor, Bambu Kağıdında Yeni Standartlar Belirliyoruz"
    },
    products: {
        subtitle: "Çeşitli İhtiyaçlarınız İçin Yüksek Kaliteli Bambu Kağıt Ürünleri",
        description: "Ham kağıttan nihai ürüne kadar, her türlü ihtiyacınız için kapsamlı kağıt ürün çözümleri sunuyoruz.",
        viewDetails: "Detayları İncele",
        categories: {
            title: "Ürün Serilerimiz",
            subtitle: "Bambu Kağıt Ürünlerimizle Yeşil Tüketime Öncülük Ediyoruz",
            livingPaper: "Hijyenik Kağıt Ham Maddeleri",
            livingPaperDesc: "Hijyenik Kağıt Ham Maddeleri Serisi",
            foodPaper: "Gıda Ambalaj Kağıtları Ham Maddeleri",
            foodPaperDesc: "Gıda Ambalaj Kağıtları Ham Maddeleri Serisi",
            finishedProducts: "Hijyenik Kağıt Nihai Ürünler Serisi"
        },
        advantages: {
            title: "Ürün Avantajlarımız",
            subtitle: "Bambuyla Gelen Taze Bir Başlangıç"
        },
        applications: {
            title: "Uygulama Alanları",
            subtitle: "Günlük Yaşamda ve Endüstrinin Birçok Alanında Yaygın Kullanım"
        },
        cta: {
            title: "Özelleştirilmiş Ürün Çözümü mü Arıyorsunuz?",
            description: "İhtiyaçlarınıza özel profesyonel bambu kağıt ürünü çözümleri sunuyoruz.",
            buttonText: "İletişim"
        },
        detail: {
            features: 'Ürün Özellikleri',
            contactUs: 'İletişim',
            specifications: 'Teknik Özellikler / Spesifikasyonlar',
            usageScenarios: 'Kullanım Senaryoları',
            relatedProducts: 'İlgili Ürünler',
            cta: {
                title: 'Daha Fazla Bilgi mi İstiyorsunuz?',
                description: 'Ürün danışmanlarımız, profesyonel tavsiye ve özel çözümler için her zaman yanınızda.',
                buttonText: 'İletişim'
            }
        },
        title: "Başlıca Ürünlerimiz"
    },
    advantages: {
        title: "Avantajlarımız",
        subtitle: "Bambu Kağıdı, Çevreci Teknoloji, Üstün Kalite",
        items: {
            experience: {
                title: "Derin Sektör Bilgisi ve Deneyimi",
                description: "80 yıllık teknoloji birikimi ve tam entegre hamur-kağıt üretim değer zincirimiz, yeşil, düşük karbonlu biyobazlı malzemelere dönüşümümüzün sağlam temelini oluşturuyor."
            },
            production: {
                title: "Olgunlaşmış ve Ölçeklenebilir Üretim Altyapısı",
                description: "Tam donanımlı, otomatik üretim hatlarımızla müşteri taleplerine hızlı yanıt veriyor, düşük maliyetli ve yüksek verimli seri üretim gerçekleştiriyoruz."
            },
            innovation: {
                title: "Sanayi-Üniversite İş Birliği ile AR-GE ve İnovasyon",
                description: "Üniversite ve araştırma kurumlarıyla ortak laboratuvarlarda, düşük karbonlu süreçler ve yenilenebilir malzemeler üzerine çalışıyor, biyobazlı malzemeler gibi ileri teknolojilerin endüstriye kazandırılmasını hızlandırıyoruz."
            },
            certification: {
                title: "Tüm Değer Zincirinde Yeşil Sertifikalar",
                description: "Hammadde tedarikinden nihai ürüne kadar FSC®, hijyen, güvenlik ve sağlık standartlarına (Medikal Sınıf, Hijyenik ve Güvenli Ürün vb.) ilişkin sertifikalarımız, ürünlerimizin piyasa rekabet gücünü artırıyor."
            }
        }
    },
    footer: {
        contact: "İletişim",
        address: "Adres: Yibin Kağıt Endüstrisi, Peishi Hafif Sanayi Parkı, Nanxi İlçesi, Yibin Şehri, Sichuan Eyaleti, Çin",
        phone: "Telefon: +86 0831-3309663",
        email: "E-posta: ybzy@yb-zy.com",
        quickLinks: "Hızlı Erişim",
        moreInfo: "Daha Fazla Bilgi",
        news: "Haberler & Duyurular",
        careers: "Kariyer Fırsatları",
        informations: "Bilgilerin açığa çıkması",
        followUs: "Bizi Takip Edin",
        wechat: "WeChat: Yibin Kağıt Endüstrisi",
        rights: "© Tüm Hakları Saklıdır.",
        slogan: "Bambu Kağıdı, Yeşil İnovasyon",
        ICPfiling: "蜀ICP备05027078号-1",
        PublicSecurityFiling: "川公网安备51150302000130号"
    },
    about: {
        companyProfile: "Şirket Profili",
        established: "1944'te Kuruldu",
        formerName: `Kuruluş: Çin Kağıt Fabrikası`,
        firstNewsprint: "Çin'in İlk Yerli Makine Yapımı Gazete Kağıdının Üretildiği Yer",
        listed: "1997'de Şanghay Borsası'nda Halka Açıldı (Hisse Kodu: 600793)",
        firstListed: "Çin Kağıt Sektörünün İlk Halka Açık Şirketi",
        firstYibinListed: "Yibin Şehrinin İlk Halka Açık Şirketi",
        wuliangyeSubsidiary: "Wuliangye Group İştirakidir",
        firstNewMeterial: `İlk "60+10" Yeni Nesil Bambu Malzeme Öncü Ürün Zinciri Liderlerinden`,
        capacity: "Üretim Kapasitemiz",
        mainCapacity: "Ana Tesis: Yıllık 540.000 Ton Hamur ve Kağıt",
        managedCapacity: "Yönetilen Tesisler: Yıllık 120.000 Ton Hamur ve Kağıt",
        newMaterialCapacity: "Yeni Malzeme: Yıllık 100 Milyon m² Oluklu Mukavva Kutu",
        bambooMoldingCapacity: "Yeni Malzeme: Yıllık 6.600 Ton Bambu Hamuru Kalıplanmış Ürün",
        celluloseCapacity: "Yeni Malzeme: Yıllık 30.000 Ton Selüloz Asetat",
        historyTitle: "Tarihçemiz",
        historySubtitle: "70 Yılı Aşkın Yolculuk: Bir Bambu Kağıdı Markası Yaratmak",
        historyItems: {
            "1944": "Çin Kağıt Fabrikası Kuruldu - Çin Kağıt Endüstrisinin Başlangıcı",
            "1945": "İlk %100 Yerli Mekanik Odun Hamuru Gazete Kağıdı Üretimi",
            "1950": `"Çin Kağıt Fabrikası", "Yibin Kağıt Fabrikası" Oldu`,
            "1961": "Başkan Zhu De Fabrika Ziyareti",
            "1966": "Mareşal Peng Dehuai Fabrika Ziyareti",
            "1988": "Hisseli Şirket Pilot Uygulaması ve Yibin Kağıt Endüstrisi A.Ş.'nin Kuruluşu",
            "1997": "Şanghay Borsası'nda İşlem Görmeye Başladı",
            "2012": "YKE'nin Yeni Tesis İnşaatı İçin Temel Atma Töreni",
            "2015": "Yeni Tesiste Gıda Ambalaj Kağıdı Ham Maddesi Hattı Devreye Alındı",
            "2018_1": "Yeni Tesiste Hijyenik Kağıt Hattı Devreye Alındı",
            "2018_2": "Wuliangye Group İştiraki Oldu",
            "2025": "Gelecek Stratejisi: Geleneksel Kağıttan, Yeşil ve Düşük Karbonlu Özel Biyobazlı Malzemeler Kapsamlı Grubuna Dönüşüm"
        },
        futureDevelopment: "Gelecek Vizyonumuz",
        future: {
            point1: "Hedeflerimize Odaklanmak",
            point2: "Bambu Kaynağının Benzersiz Avantajlarını Kullanmak",
            point3: "Özelleşmiş, Yüksek Teknoloji ve Yüksek Katma Değerli İşlere Dönüşümü Hızlandırmak",
            point4: "Kağıt Ürünleri Niche Pazarında Küresel Bir Lider Olmak"
        },
        coreValues: "Kurumsal Felsefemiz",
        coreValuesSubtitle: "Bambu İskeletimiz, Kağıt Ruhumuz. Yeşil İnovasyonla Büyüyoruz.",
        values: {
            mission: "Misyonumuz",
            missionLine1: "Biyolojik Yeni Malzemeleri Temel Almak",
            missionLine2: "Daha Yeşil, Daha Düşük Karbonlu Bir Dünya İnşa Etmek",
            vision: "Vizyonumuz",
            visionLine1: "Yeşil ve Düşük Karbonlu Özel Biyobazlı",
            visionLine2: "Malzeme Endüstrisinde Lider Bir Grup Olmak",
            coreValues: "Temel Değerlerimiz",
            coreValuesLine1: "Kalite Öncelikli, Yenilikle Güçlenen",
            coreValuesLine2: "Sürdürülebilir Büyüme, Birlikte Başarı",
            philosophy: "İşletme Anlayışımız",
            philosophyLine1: "Müşteri Odaklılık",
            philosophyLine2: "Kalite Temelli, Yenilikle Tahrik Edilen"
        },
        certificationsTitle: "Sertifikalarımız ve Akreditasyonlarımız",
        certificationsSubtitle: "Kalite Güvencesi, Sektörde Tanınırlık",
        certificationItems: {
            fsc: "Uluslararası Orman Yönetimi Sertifikası (FSC®)",
            fscDesc: "FSC®: Sorumlu Orman Yönetiminden Elde Edilen Hammaddeler",
            iso9001: "ISO 9001 Kalite Yönetim Sistemi",
            iso9001Desc: "Uluslararası Kalite Yönetim Sistemi Sertifikası",
            iso14001: "FSSC 22000 Gıda Güvenliği Sistemi",
            iso14001Desc: "Gıda Güvenliği Sistemi Sertifikasyonu",
            medical: "Medikal/Hijyen Sınıfı Ürün Sertifikaları",
            medicalDesc: "Medikal/Hijyen Sınıfı Ürün Sertifikasyonları",
            antibacterial: "Antibakteriyel ve Hijyen Sertifikaları",
            antibacterialDesc: "Antibakteriyel ve Hijyen Sertifikasyonları",
            safety: "Hijyenik ve Güvenli Ürün Sertifikaları",
            safetyDesc: "Hijyenik ve Güvenli Ürün Sertifikasyonları"
        },
        honorsTitle: "Ödüllerimiz ve Başarılarımız",
        honorsSubtitle: "Kalite Güvencesi, Sektörde Tanınırlık",
        honorItems: {
            greenFactory: "Ulusal Yeşil Fabrika (Çin MIIT)",
            greenFactoryDesc: "Yeşil Üretimde Öncü Şirket (Çin MIIT)",
            forestryLeader: "Ulusal Ormancılık Sektöründe Kilit Lider Şirket (NFGA)",
            forestryLeaderDesc: "Ormancılık ve Çayır Sektöründe Kilit Lider Şirket (NFGA)",
            agriculturalProduct: "Çin'in Seçkin Tarımsal Ürün Şirketi",
            agriculturalProductDesc: "Çin'in Seçkin Tarımsal Ürün Şirketi Markası",
            lightIndustry: "Ulusal Hafif Sanayi Sektörü İleri Kolektifi",
            lightIndustryDesc: "Ulusal Hafif Sanayi Sektörü İleri Kolektifi",
            bambooProduct: "En İyi 10 Bambu Ürünleri Şirketi",
            bambooProductDesc: "Çin Bambu Endüstrisinde En İyi 10 Marka",
            engineeringCenter: "Kağıt Mühendisliği Teknolojisi Araştırma Merkezi",
            engineeringCenterDesc: "Sichuan Eyaleti Bambu Hamuru ve Kağıt Üretimi Mühendislik Teknolojisi Araştırma Merkezi"
        },
        productHonorsTitle: "Ürün Ödüllerimiz",
        productHonorsSubtitle: "Kalite Güvencesi, Sektörde Tanınırlık",
        productHonorItems: {
            industryExcellence: "Sektörde Özenle Tasarlanmış Ürün",
            neZhaExcellence: "Nezha Serisi: 2025 Çin Hijyenik Kağıt Sektörü Özenle Tasarlanmış Ürün Ödülü",
            moDiKaExcellence: "Modica Serisi: Çin Hijyenik Kağıt Sektörü Özenle Tasarlanmış Ürün Ödülü",
            bambooExpoGold: "Uluslararası Bambu Fuarı Altın Madalyası",
            moDiKaGold: "Modica Serisi: 2025 Uluslararası Bambu Fuarı Altın Madalyası",
            shanghaiExpoGold: "Uluslararası Bambu Fuarı Altın Madalyası",
            jinZhuGold: "Jinzhu Doğal Renk Serisi: 2020 Şanghay Uluslararası Bambu Fuarı Altın Madalyası",
            quanZhuGold: "Tam Bambu Ambalaj Ham Kağıdı: 2018 Şanghay Uluslararası Bambu Fuarı Altın Madalyası",
            westernExpoGold: "Çin Batı Ormancılık Endüstrisi Fuarı Altın Madalyası",
            jinZhuWesternGold: "Jinzhu Doğal Renk Serisi: Çin Batı Orman Ürünleri Fuarı Altın Madalyası"
        },
        cta: {
            title: "YKE ile Yeşil Bir Gelecek İnşa Edin",
            description: "Sizinle iş birliği yaparak, bambu kağıdı endüstrisinin sürdürülebilir geleceğine birlikte katkıda bulunmayı dört gözle bekliyoruz.",
            buttonText: "İletişim"
        }
    },
    technology: {
        title: 'Teknoloji ve İnovasyon',
        subtitle: 'Teknolojiyle Öncülük, Yeşil Devrim: Bambu Kağıdında Yeni Standartlar',
        innovation: {
            title: 'İnovasyonla Büyüme',
            subtitle: 'Teknolojiyle Öncülük, Yeşil Devrim: Bambu Kağıdında Yeni Standartlar',
            management: {
                title: 'Etkin İnovasyon Yönetimi',
                content: "YKE'de teknolojik inovasyon, büyümemizin ana itici gücüdür. Strateji ve Gelişim Komitemiz, AR-GE, üretim ve pazarlamayı entegre ederek güçlü bir altyapı oluşturur."
            },
            team: {
                title: 'Profesyonel Ekiplerle Teknolojik Atılımlar',
                content: 'Eyalet inovasyon platformu ve AR-GE ekibimizle, önde gelen üniversite ve araştırma kurumlarıyla iş birliği içinde, düşük karbonlu hamur ve biyobazlı malzemeler gibi öncü alanlarda projeler yürütüyor, inovatif büyümeye güç katıyoruz.'
            },
            results: {
                title: 'İnovasyonla Endüstriyel Dönüşüm',
                content: 'Bambudan kağıda tüm sürecin temel teknolojilerine hakimiz. Yeşil hamur, temiz üretim ve kaynak verimliliğindeki sürekli atılımlarımız, yeşil, düşük karbonlu biyobazlı malzeme endüstrisine dönüşümümüzü yönlendiriyor.'
            }
        },
        core: {
            title: 'Çekirdek Teknolojiler',
            subtitle: 'Bilim ve Teknoloji Öncülüğünde Yeşil İnovasyon',
            tabs: {
                pulping: 'Bambu Hamuru Üretim Teknolojisi',
                bleaching: 'Döngüsel Ekonomi Çekirdek Teknolojileri',
                papermaking: 'Yeşil Ürün İnovasyon Teknolojileri'
            },
            items: {
                pulping: {
                    details: [
                        {
                            title: 'Bambu Ön İşleme Teknoloji Sistemi',
                            content: "Bambunun yüksek yoğunluk ve yüksek silika içeriği işleme zorluklarını aştık, homojen bambu emprenye teknolojisi geliştirdik, enerji tüketimini %10'dan fazla azalttık."
                        },
                        {
                            title: 'Düşük Karbonlu Temiz Hamur Üretim Teknolojisi',
                            content: `"Derin Delignifikasyon-ECF Ağartma" kombine prosesi, AOX emisyonlarını ulusal standartlara göre %30'dan fazla düşürdü; "anaerobik+aerobik+Fenton" su arıtma teknolojisini entegre ederek COD emisyonlarını ulusal standartlara göre %50'den fazla azalttı.`
                        }
                    ]
                },
                bleaching: {
                    details: [
                        {
                            title: 'Bambu Bileşenlerinin Tam Kullanım Teknolojisi',
                            content: 'Bambu selülozu hamur ve kağıt üretiminde kullanılır; siyah likör lignini yakılarak ısı enerjisi geri kazanılır, ton başına hamur 350kWh elektrik üretebilir; hamur üretim atıkları biyogübre hazırlamak için doğaya geri döndürülür.'
                        }
                    ]
                },
                papermaking: {
                    details: [
                        {
                            title: 'Fonksiyonel Bambu Lifi Ürünleri',
                            content: `Bambu lifi güçlendirme teknolojisi, ambalaj kağıdının çekme ve katlanma direnç indekslerini %50'den fazla artırır, ürüne daha iyi performans kazandırır; kendinden antibakteriyel yaşam kağıdı ürünleri geliştirilir, bambunun doğal antibakteriyel bileşenleri kullanılarak aynı koşullarda antibakteriyel verimlilik %90'dan fazla artırılır.`
                        },
                        {
                            title: 'Biyobazlı Yeni Malzemeler',
                            content: 'Bambu lifi ürünleri plastik ürünlerin yerini alır, karbon ayak izi %60 azalır.'
                        }
                    ]
                }
            }
        },
        research: {
            title: 'Ar-Ge Merkezi',
            subtitle: `Ar-Ge'ye Odaklanmak, Değer Yaratmak`,
            imageAlt: 'Yibin Paper Industry Ar-Ge Merkezi',
            center: {
                title: 'Ar-Ge ve İnovasyon Platformu',
                content: 'Ar-Ge Merkezi 2003 yılında kuruldu, şirketin teknolojik inovasyonunun çekirdek departmanıdır, sektör gelişim eğilimlerine odaklanır, bilimsel ve teknolojik başarıların dönüştürülmesini teşvik eder. Şirket şu anda eyalet düzeyinde kurumsal teknoloji merkezidir, Sichuan Eyaleti Bambu Hamuru ve Kağıt Üretimi Mühendislik Teknolojisi Araştırma Merkezi olmak üzere 2 eyalet düzeyinde inovasyon platformuna sahiptir. "Yeni Tip Bambu Endüstrisi Endüstri-Eğitim Entegrasyon Topluluğu" kurulmasına öncülük etmiş ve "Bambu Hamuru-Kağıt Entegrasyonu Anahtar Teknolojileri Araştırması" ulusal önemli özel projesine katılmıştır. Bambu hamuru kağıdı üretiminin anahtar teknoloji alanlarında zengin deneyim biriktirmiş, güçlü bir teknolojik rekabet avantajı oluşturmuştur.'
            },
            cooperation: {
                title: 'İşbirlikçi Ar-Ge',
                content: 'Merkez, Sichuan Tarım Üniversitesi, Güney Çin Teknoloji Enstitüsü, Pekin Ormancılık Üniversitesi, Nanjing Ormancılık Üniversitesi, Çin Ormancılık Bilimi Akademisi gibi çok sayıda üniversite ve araştırma kurumuyla uzun vadeli işbirliği ilişkileri kurmuştur, ulusal ve eyalet düzeyindeki bilimsel araştırma projelerini birlikte üstlenmekte, endüstri-akademi-araştırma entegrasyonunu derinleştirmeyi teşvik etmektedir.'
            }
        },
        patents: {
            title: 'Patentler ve Başarılar',
            subtitle: 'Teknolojik Birikim, Sektör Liderliği',
            authorized: {
                title: 'Verilmiş Patentler',
                items: [
                    'Bir Rafine Karışık Bambu Hamuru ve Hazırlama Yöntemi ile Bu Rafine Karışık Bambu Hamurunun Kağıt Yapımında Uygulaması',
                    'Bir Rafine Bambu Hamuru ve Hazırlama Yöntemi ile Bu Rafine Bambu Hamurunun Kağıt Yapımında Uygulaması',
                    'Bir Alkali Geri Kazanım Fırını Siyah Likör Püskürtme Tabancası',
                    'Bir Lif Eleme Cihazı'
                ]
            },
            projects: {
                title: 'Bilimsel Araştırma Projeleri',
                items: [
                    'Yüksek Hacimli Yüksek Mukavemetli Bambu Hamuru Temiz Enerji Verimli Üretimi ve Yüksek Mukavemetli Ambalaj Kartonu Harmanlama Teknolojisi Araştırması',
                    'Bambu Kimyasal Hamuru Saflaştırma ve Yüksek Kaliteli Yaşam Kağıdı Harmanlama Teknolojisi Araştırması',
                    'Bambu Bazlı Hamur Derin İşleme Teknolojisi Araştırması ve Geliştirilmesi',
                    'Bambu Bazlı Yüksek Kaliteli Selüloz Lifleri Araştırması ve Geliştirilmesi',
                    'Fonksiyonel Ligninin Yüksek Değerli Ürünler Olarak Araştırılması ve Geliştirilmesi'
                ]
            },
            awards: {
                title: 'Bilim ve Teknoloji Ödülleri',
                items: [
                    'Sichuan Eyaleti Bilim ve Teknoloji İlerleme Birincilik Ödülü'
                ]
            },
            papers: {
                title: 'Araştırma Makaleleri',
                items: [
                    'Katyonik Dispersiyon Reçinesinde Toplam Reçine ve Alüminyum Sülfat İçeriğinin Belirlenmesi',
                    'Bambu Kimyasal-Mekanik Hamuru İçeren Doğal Renkli Gıda Kartonunun Deneysel Üretimi',
                    'Pişirme Yardımcı Maddelerinin Tam Bambu DDS Pişirmesinde Uygulanması',
                    'Lif Sınıflandırması Yoluyla Bambu Lif Kaynaklarının Çözünür Hamur Üretiminde Verimli Kullanımı için Yeni Proses: Laboratuvar Araştırması ve Fabrika Testi',
                    'Ligninin Yüksek Değerli Kullanımı için Ultrasonik Kavitasyonla Depolimerizasyon Tandem Stratejisi'
                ]
            }
        },
        projects: {
            title: 'İnovatif Projeler',
            subtitle: 'Sektörün Gelecek Gelişim Yönüne Öncülük Etmek',
            items: [
                {
                    title: 'Sichuan Bambu Endüstri Zinciri Anahtar Teknoloji Entegrasyonu ve Demo Fabrikası',
                    period: '2019-2022',
                    cooperation: 'Sichuan Tarım Üniversitesi',
                    desc: 'Bambu kaynak zinciri ile endüstri zincirinin organik entegrasyonu, bambu endüstrisinin gelişimini teşvik eder.'
                },
                {
                    title: 'Yibin Ormancılık ve Bambu Endüstrisi Yüksek Teknoloji İnovasyon Platformu İnşası ve Demonstrasyonu',
                    period: '2019-2022',
                    cooperation: 'Güney Çin Teknoloji Enstitüsü',
                    desc: 'Düşük kükürtlü bambu pişirme teknolojisi, siyah likörün yüksek değerli kullanım teknolojisi vb. alanlarda atılımlar elde edildi.'
                },
                {
                    title: 'Bambu Bazlı Hamurun Derin İşleme Teknolojisi Araştırması ve Geliştirilmesi',
                    period: '2022-2024',
                    cooperation: 'Çin Ormancılık Bilimi Akademisi',
                    desc: 'Bambuda yüksek verimli hamur üretimi gibi anahtar teknolojilerde atılım, endüstriyel uygulama, hammadde ithal ikamesinin gerçekleştirilmesi.'
                },
                {
                    title: 'Fonksiyonel Ligninin Yüksek Değerli Ürünler Olarak Araştırılması ve Geliştirilmesi',
                    period: '2022-2024',
                    cooperation: 'Pekin Ormancılık Üniversitesi',
                    desc: 'Bambu hamuru siyah liköründen kademeli lignin bileşen ekstraksiyonu ile yan ürün hazırlanması, siyah likörün yüksek değerli kullanım yollarında atılım.'
                },
                {
                    title: 'Bambu Hamuru-Kağıt Entegrasyonu Anahtar Teknolojileri Araştırması',
                    period: '2023-2028',
                    cooperation: 'Çin Ormancılık Bilimi Akademisi',
                    desc: 'Yüksek verimli homojen emprenye yumuşatma, hassas ayırma enerji tasarrufu sağlama, alkali hidrojen peroksit aktivasyonlu ağartma gibi anahtar teknolojiler.'
                },
                {
                    title: 'Akıllı Bambu Endüstrisi Anahtar Teknolojileri Araştırması ve Entegre Demonstrasyonu',
                    period: '2024-2027',
                    cooperation: 'Nanjing Ormancılık Üniversitesi',
                    desc: 'Bambu hamuru kağıt üretim şirketlerinde temiz üretim, kaynakların kapsamlı kullanımı gibi anahtar teknolojik zorluklar üzerine konu araştırması yürütülmektedir.'
                }
            ]
        },
        cta: {
            title: 'Bambu Hamuru Kağıt Üretiminin Geleceğini Birlikte Keşfedelim',
            subtitle: 'Bambu hamuru kağıt teknolojisi inovasyonuna ilgi duyan ortaklar bize ulaşabilir, sektör gelişimini birlikte teşvik edebiliriz',
            button: 'İletişim'
        }
    },
    sustainability: {
        title: 'Sürdürülebilir Kalkınma',
        subtitle: 'Bambu Temelli, İnovasyon Kanatlı, Yeşil Düşük Karbonlu Biyobazlı Malzeme Endüstrisi Kılavuzu Oluşturmak',
        vision: {
            title: 'Sürdürülebilir Kalkınma Vizyonu',
            content: 'Bambu Temelli, İnovasyon Kanatlı, Yeşil Düşük Karbonlu Biyobazlı Malzeme Endüstrisi Kılavuzu Oluşturmak',
            imageAlt: 'Yibin Paper Industry Sürdürülebilir Kalkınma Vizyonu',
            intro1: 'Bambu hamuru ve kağıt üretim sektöründe bir yenilikçi olarak,',
            intro2: 'Yibin Paper Industry, "bambu kaynaklarının verimli kullanımı + düşük karbon teknolojisi"yi çekirdek ilke edinerek, geleneksel endüstrinin yeşil, yüksek katma değerli ve döngüsel dönüşümünü teşvik ediyor.',
            items: {
                circular: {
                    title: 'Yeşil ve Düşük Karbonla Döngüsel Ekonomiye Öncülük',
                    content: 'Bambunun yenilenebilir, hızlı büyüyen ve güçlü karbon tutma kapasitesi özelliklerinden yararlanarak, "bambu kaynağı - temiz hamur üretimi - biyobazlı malzemeler - düşük karbonlu ürünler" tam tedarik zincirini oluşturuyor, "sıfır atık, tam kullanım"ı gerçekleştiriyor ve 2030 Karbon Pik ve 2060 Karbon Nötr hedeflerine katkıda bulunuyor.'
                },
                innovation: {
                    title: 'Teknolojik Yenilikle Yüksek Değerli Dönüşüm',
                    content: 'Bambu liflerinin yüksek katma değerli kullanım teknolojilerinde atılımlar yaparak, biyolojik olarak parçalanabilir ambalajlar, biyobazlı kompozit malzemeler gibi plastiğe alternatif yeni ürünler geliştiriyor ve yaşam döngüsü boyunca karbon ayak izini azaltıyor.'
                },
                rural: {
                    title: 'Ekolojik Kazan-Kazanla Kırsal Canlanmayı Güçlendirme',
                    content: '"Bambu ormanı üssü + yeşil fabrika + toplulukla bütünleşme" modeli aracılığıyla, bambu ormanlarının karbon tutma gelirlerini artırmayı teşvik ediyor, tedarik zincirinin yukarı ve aşağı kısımlarının uyumlu gelişimini sağlıyor ve çevresel, ekonomik ve sosyal faydaların bütünleşmesini gerçekleştiriyor.'
                },
                cooperation: {
                    title: 'Açık İşbirliğiyle Sürdürülebilir Geleceği İnşa',
                    content: 'Araştırma kurumları ve endüstri zinciri ortaklarıyla bir araya gelerek, bambu bazlı malzeme standartlarının belirlenmesini ve teknolojinin yaygınlaştırılmasını teşvik ediyor, "bambunun plastiğin ve ağacın yerine geçmesini" küresel bir yeşil çözüm haline getiriyor.'
                }
            },
            commitment: {
                title: 'Taahhüdümüz:',
                content: 'Her bambu, doğa ile teknolojinin simbiyozudur; her yenilik, Dünya ve insanlığın geleceği içindir.'
            }
        },
        cleanProduction: {
            title: 'Temiz Üretim',
            subtitle: 'Yenilikçi teknolojiyle yeşil suları ve dağları koruyor, temiz üretimle sürdürülebilir kalkınmaya öncülük ediyoruz',
            description: 'Bambu hamuru ve kağıt endüstrisinin yeşil öncüsü olarak Yibin Paper Industry, her zaman "çevre koruma öncelikli, yeşil kalkınma" felsefesini uyguluyor. Temiz üretim süreçleri, kaynak geri dönüşümü ve düşük karbonlu teknolojik yeniliklerle, verimli, temiz ve sürdürülebilir modern bir kağıt endüstrisi inşa ederek küresel müşterilere yeşil kağıt ürün çözümleri sunuyor.',
            items: {
                raw: {
                    title: 'Yeşil Hammaddeler, Düşük Karbon Kaynağı',
                    subtitle: '%100 Sürdürülebilir Bambu Lifi, Üretim Atıklarının Kapsamlı Değerlendirilmesi',
                    points: [
                        'Hızlı büyüyen bambu ormanı kaynakları kullanılarak orman tahribatı azaltılır.',
                        'Bambu büyüme sürecinde güçlü karbon tutma kapasitesiyle, kaynakta karbon emisyonları düşürülür.',
                        'Bambu talaşı, beyaz çamur vb. üretim atıklarının kapsamlı değerlendirme yolları araştırılarak kaynakların verimli döngüsü sağlanır.'
                    ]
                },
                process: {
                    title: 'Temiz Süreçler, Enerji Tasarrufu ve Tüketim Azaltımı',
                    subtitle: 'Düşük kirliliğe sahip hamur üretim teknolojisi, atık su ve gazlarda ultra düşük emisyon',
                    points: [
                        'Elementsiz klor (ECF) ağartma, oksijenle delignifikasyon gibi ileri süreçler kullanılarak AOX (adsorbe edilebilir organik halojenler) vb. zararlı madde emisyonları önemli ölçüde azaltılır.',
                        'Aerobik biyolojik arıtma vb. teknoloji kombinasyonlarıyla atık su standartlara uygun şekilde deşarj edilir, gri su hammadde yıkamada yeniden kullanılarak taze su tüketimi azaltılır.',
                        'Alkali geri kazanım kazanı + elektrostatik toz tutucu + ıslak kükürt giderme sistemi ile donatılarak, baca gazı emisyonlarının ulusal standartlardan daha iyi olması sağlanır.'
                    ]
                },
                recycle: {
                    title: 'Döngüsel Ekonomiyle Atıkları Değere Dönüştürme',
                    subtitle: 'Siyah likör %100 geri kazanılır, çamur kaynak olarak değerlendirilir, atık ısı yeniden kullanılır.',
                    points: [
                        "Hamur üretim atık sıvısı alkali geri kazanım sistemiyle ısı enerjisine ve kimyasallara dönüştürülür, kendi kendine yeterlilik oranı %85'in üzerindedir, fosil enerji bağımlılığı azaltılır.",
                        'Kağıt üretim çamuru organik gübre veya biyokütle yakıtı üretmek için kullanılarak katı atıklarda "sıfır depolama" sağlanır.',
                        'Üretim sürecindeki atık ısı elektrik üretimi için kullanılarak enerji kullanım verimliliği artırılır.'
                    ]
                },
                product: {
                    title: 'Yeşil Ürünlerle Düşük Karbonlu Yaşam',
                    subtitle: 'Biyolojik olarak parçalanabilir ambalaj kağıdı, FSC sertifikalı ürünler',
                    points: [
                        'Bambu lifli, gıda sınıfı ambalaj kağıdı, plastik ürünlerin yerini alarak "beyaz kirliliği" azaltır.',
                        'Kağıdın kaynağının uluslararası orman sürdürülebilir yönetim standartlarına uygun olduğu garanti edilir, üst düzey pazar talepleri karşılanır.'
                    ]
                }
            }
        },
        circularEconomy: {
            title: 'Döngüsel Ekonomi',
            subtitle: 'Bambu Tam Kullanım, Sonsuz Döngü',
            imageAlt: 'Döngüsel Ekonomi Modeli Şeması',
            intro: {
                title: 'Ağacın Yerine Bambu, Yeşille Güçlendirme',
                content: 'Bambu kaynaklarının verimli kullanımının savunucusu olarak, "bambu-hamur-kağıt-enerji-gübre" beşli birimli döngüsel ekonomi modelini oluşturduk, her bambuya yeşil enerji kazandırıyoruz.'
            },
            items: {
                source: {
                    title: 'Yeşil Başlangıç: Sürdürülebilir Bambu Kaynağı',
                    points: [
                        'Ekolojik bambu ormanı demonstrasyon alanları kurulur, dönüşümlü hasat yönetim modeli uygulanır.',
                        'Bambu hızlı büyür (3-5 yılda olgunlaşır), karbon tutma kapasitesi Çin göknarının 1.5 katıdır.',
                        '100.000 çiftçi hanesinin gelir artışı sağlanır, "yeşil sular ve dağlar"ın "altın ve gümüş dağlara" dönüşümü gerçekleştirilir.'
                    ]
                },
                core: {
                    title: 'Temel Döngü: Üç Atıkta Sıfır Emisyon',
                    points: [
                        'Atık Sıvı → Enerji: Hamur üretim siyah likörü %100 geri kazanılır, yıllık 60 milyon kWh elektrik üretilir.',
                        'Atık Gaz → Kaynak: Kazan baca gazı atık ısısı geri kullanılır, CO2 emisyonları azaltılır.',
                        'Atık Katı → Karbon Kaynağı: Bambu talaşı biyokütle pelet yakıtına dönüştürülür.'
                    ]
                },
                upgrade: {
                    title: 'Ürün Yükseltme: Bambunun Tam Kullanımı',
                    points: [
                        'Yüksek kaliteli bambu hamurlu gıda ambalajları, hijyenik kağıtlar (FSC sertifikalı).',
                        'Bambu lifli biyolojik olarak parçalanabilir ambalaj malzemeleri (plastik alternatifi).',
                        'Bambu talaşı ve posası biyokütle atık yakıtı hazırlamak için kullanılır.'
                    ]
                }
            },
            vision: {
                title: 'Vizyonumuz:',
                content: 'Her bambunun karbon yutağından ürüne yeşil yolculuğunu tamamlamasını sağlamak.'
            }
        },
        socialResponsibility: {
            title: 'Sosyal Sorumluluk',
            subtitle: 'Sessizce Besleyen, İyiliği Dünyaya Yayan',
            tabs: {
                community: 'Topluluk Gelişimi',
                farmers: 'Çiftçi Gelir Artışına Destek',
                education: 'Yetenek Geliştirme',
                biodiversity: 'Çevre Dostu'
            },
            community: {
                title: 'Kırsal Canlanma Planı',
                description: 'Yibin Paper Industry, ulusal kırsal canlanma stratejisine aktif olarak yanıt vererek, "şirket + kooperatif + çiftçi" modeli aracılığıyla çevre köylerde bambu endüstrisinin gelişimini teşvik ediyor ve kırsal ekonomi canlılığını artırıyor.',
                items: {
                    village: {
                        title: 'Köyde Görevlendirme',
                        content: "Şirket, Cuiping Bölgesi Yongxing Kasabası Shizi Köyü'ne köy kalkınma sorumlusu (ilk parti sekreteri) olarak iki parti üyesi ve personel gönderdi; Jiang'an İlçesi Yangchun Kasabası Xingwang Köyü'ne köy destek çalışanı olarak bir parti üyesi ve personel gönderdi."
                    },
                    manager: {
                        title: 'Köy Kolektif Ekonomisi Profesyonel Yöneticileri',
                        content1: 'Köye "profesyonel yönetici" olarak iki yetenekli personel gönderildi; köy bütçesi denetimi, sistem standartlaştırması, pazar genişletme, ürün pazarlama, yönetim yeteneklerinin geliştirilmesi gibi çalışmaları yürütmekte ve köy kolektif ekonomisinin standartlaşması, piyasalaşması ve profesyonelleşmesine yardımcı olmaktadır.',
                    },
                    project: {
                        title: 'Xingwen İlçesi Dahe Miao Etnik Kasabası Endüstri Gelişimi İşbirliği ve Kazan-Kazan Bire Bir Bağlantı Projesi',
                        content: '"Yibin Şehri İşletmelerin Etnik Kasabalarla İşbirliği ve Kazan-Kazan Bire Bir Bağlantı Mekanizması İşletme Planı" çalışma gerekliliklerine göre, şirket Xingwen İlçesi Dahe Miao Etnik Kasabası ile bağlantı kurarak bambu hammadde satış zorluklarını çözmektedir.'
                    }
                }
            },
            farmers: {
                title: 'Çiftçi Gelir Artışına Destek Projesi',
                description: 'Yerel bambu çiftçileriyle istikrarlı işbirliği ilişkileri kuruyoruz; doğrudan satın alma modelleri, akıllı ekipman yatırımları, bilimsel ıslahın yaygınlaştırılması gibi önlemlerle bambu çiftçilerinin gelirlerini artırmalarına ve ortak refahı gerçekleştirmelerine yardımcı oluyoruz.',
                imageAlt: 'Çiftçi Gelir Artışına Destek Projesi',
                items: {
                    direct: {
                        title: 'Doğrudan Satın Alma ve Kontrol ile Aracılar Ortadan Kaldırılır, Çiftçi Çıkarları Korunur',
                        content1: 'Geleneksel satın alma modeli kırılarak, "şirket + uzman kooperatif malzeme sahası + çiftçi", "şirket + kendi malzeme sahası + çiftçi" gibi çeşitli doğrudan satın alma modelleri kurulur.',
                        content2: 'Birinci ve ikinci sanayi arasında derin işbirliği güçlendirilir, aracılar ortadan kaldırılır, her aşamadaki maliyet potansiyeli kazılır; hammadde tedarikini güvence altına alırken, bambu çiftçilerinin bambu satmasını kolaylaştırır, bambu fiyatını istikrara kavuşturur ve çiftçilerin çıkarlarını korur.'
                    },
                    tech: {
                        title: 'Teknolojiyle Endüstri Yükseltilir, Çiftçi Geliri Artırılır',
                        content1: 'Akıllı ekipman yatırımları artırılır; bambu kesimi ve nakliye aşamalarına odaklanarak, bambu kesebilen ve taşıyabilen makine ve ekipman araştırılır.',
                        content2: 'Bambu kesim ve nakliye verimliliği kapsamlı olarak artırılır, işgücü tamamen serbest bırakılır, kesim maliyetleri düşürülür ve teknolojik faydalar bambu çiftçileriyle paylaşılır, çiftçi geliri artırılır.',
                        content3: 'Bilimsel ıslah, dikim ve bakım demonstrasyonlarıyla, yüksek verimli bambu ormanı demonstrasyonu ve teşvik etkisi gerçekleştirilir.',
                        content4: 'Bambu çiftçileri bilimsel ekim için yönlendirilir, dikim ve bakım maliyetleri düşürülür, dönüm başına verim artırılır, bambu çiftçilerinin ekim geliri artırılır.'
                    },
                    value: {
                        title: 'Katma Değer Yaratacak İşbirlikleriyle Kanallar Genişletilir, Kapsamlı Gelir Artırılır',
                        content1: 'Çeşitli işbirliği modelleri aktif olarak araştırılır, bambu ormanlarının kereste dışı gelir kaynakları harekete geçirilir; üçüncü taraf kuruluşlarla birleşerek bambu ormanı karbon tutma ticareti pilot çalışması yapılır, çiftçiler bakım performanslarına göre ek temettü alabilir.',
                        content2: 'Aynı zamanda orman altı tarım ve hayvancılığın geliştirilmesi yönlendirilerek bambu ormanlarının kapsamlı geliri artırılır; orman altı ekonomisi ile karbon tutma yönetimi birleştirilerek bambu ormanlarının karbon tutma kapasitesi artırılır, çiftçi geliri artırılır, "ekoloji + ekonomi" kazan-kazanı sağlanır.'
                    }
                }
            },
            education: {
                title: 'Bambu Bazlı Personel Yetiştirme Planı',
                description: 'Nitelikli personel, gelişmenin temel itici gücüdür. İnsan kaynaklarının geliştirilmesine büyük önem veriyor; çok yönlü yetenek geliştirme sistemleri kurarak sektörün geleceğinin liderlerini yetiştiriyoruz.',
                imageAlt: 'Personel Yetiştirme Programı',
                items: {
                    mechanism: {
                        title: 'Çok Yönlü Yetenek Geliştirme Sistemi',
                        content: 'Usta-çırak modeli, yedek yetenek havuzu, iş rotasyonu ve kişiye özel eğitim programları gibi yöntemlerle çalışanlarımızın iş hayatına yeni başlayan bireylerden sektör uzmanlarına dönüşüm yolculuğuna destek oluyoruz.'
                    },
                    path: {
                        title: 'Net Kariyer Yolları',
                        content: 'Sürekli iyileştirilen kariyer yolları ve çeşitli gelişim fırsatları sayesinde her çalışanımız uzmanlık alanında parlayabilir ve şirketle birlikte yeni büyüme hedeflerine yürüyebilir.'
                    }
                }
            },
            biodiversity: {
                title: 'Yeşil Fabrika Planı',
                description: 'Ulusal karbon nötrlüğü ve zirvesi hedeflerini aktif olarak destekliyor; sürdürülebilirliği stratejik önceliğimiz haline getirerek çevre yönetim sistemimizi sürekli iyileştiriyoruz.',
                imageAlt: 'Çevre Dostu Proje',
                items: {
                    policy: {
                        title: '"Ahşap Yerine Bambu" "Plastik Yerine Bambu"',
                        content: 'Hükümetin "Ahşap Yerine Bambu" ve "Plastik Yerine Bambu" politikalarına tam destek veriyor; üretimin doğal kaynaklar üzerindeki etkisini en aza indiriyor, düşük karbonlu ekonomiye geçişi hızlandırıyor ve böylece ekonomik ve çevresel açıdan kazan-kazan durumu yaratıyoruz.'
                    },
                    factory: {
                        title: 'Yeşil Fabrika',
                        content: 'FSC Orman Yönetimi (FM) ve Ticaret Zinciri (CoC) Sertifikalarına sahiptir. Ulusal "Yeşil Fabrika" unvanı ile Sichuan Eyaleti "Temiz Üretim" işletmesi olarak tanınmıştır. Ürünlerimiz "Sichuan Eyaleti Enerji Tasarrufu ve Çevre Koruma Markası Mükemmel Ürün Ödülü"nü almıştır.'
                    }
                }
            }
        },
        report: {
            title: 'Sürdürülebilir Kalkınma Raporu',
            subtitle: 'Şeffaf, Doğru ve Kapsamlı Sürdürülebilir Kalkınma Bilgi Paylaşımı',
            download: 'Raporu İndir',
            items: {
                '2024': {
                    title: '2024 Sürdürülebilir Kalkınma Raporu',
                    date: 'Yayın Tarihi: Nisan 2024',
                    imageAlt: '2024 Sürdürülebilir Kalkınma Raporu'
                },
                '2023': {
                    title: '2023 Sürdürülebilir Kalkınma Raporu',
                    date: 'Yayın Tarihi: Nisan 2023',
                    imageAlt: '2023 Sürdürülebilir Kalkınma Raporu'
                }
            }
        },
        cta: {
            title: 'Bizimle Birlikte, Sürdürülebilir Bir Gelecek İnşa Edin',
            description: "Yibin Kâğıt'ın sürdürülebilirlik uygulamaları hakkında daha fazla bilgi edinin veya yeşil dönüşümü birlikte hızlandırmak için bizimle iş birliği yapın.",
            buttonText: 'İletişim'
        }
    },
    home: {
        advantages: {
            title: "Avantajlarımız",
            subtitle: "Bambu Kağıdı, Çevreci Teknoloji, Üstün Kalite",
            items: {
                experience: {
                    title: "Derin Sektör Bilgisi ve Deneyimi",
                    description: "80 yıllık teknoloji birikimi ve tam entegre hamur-kağıt üretim değer zincirimiz, yeşil, düşük karbonlu biyobazlı malzemelere dönüşümümüzün sağlam temelini oluşturuyor."
                },
                production: {
                    title: "Olgunlaşmış ve Ölçeklenebilir Üretim Altyapısı",
                    description: "Tam donanımlı, otomatik üretim hatlarımızla müşteri taleplerine hızlı yanıt veriyor, düşük maliyetli ve yüksek verimli seri üretim gerçekleştiriyoruz."
                },
                innovation: {
                    title: "Sanayi-Üniversite İş Birliği ile AR-GE ve İnovasyon",
                    description: "Üniversite ve araştırma kurumlarıyla ortak laboratuvarlarda, düşük karbonlu süreçler ve yenilenebilir malzemeler üzerine çalışıyor, biyobazlı malzemeler gibi ileri teknolojilerin endüstriye kazandırılmasını hızlandırıyoruz."
                },
                certification: {
                    title: "Tüm Değer Zincirinde Yeşil Sertifikalar",
                    description: "Hammadde tedarikinden nihai ürüne kadar FSC®, hijyen, güvenlik ve sağlık standartlarına (Medikal Sınıf, Hijyenik ve Güvenli Ürün vb.) ilişkin sertifikalarımız, ürünlerimizin piyasa rekabet gücünü artırıyor."
                }
            }
        },
        products: {
            title: "Başlıca Ürünlerimiz",
            subtitle: "Çeşitli İhtiyaçlarınız İçin Yüksek Kaliteli Bambu Kağıt Ürünleri",
            items: {
                bambooPulp: {
                    title: "Saf Bambu Hamuru",
                    description: "Özenle Seçilmiş Bambu Türleri, Yüksek Kaliteli Bambu Lifleri",
                    alt: "Bambu Hamuru"
                },
                packagingPaper: {
                    title: "Saf Bambu Hamurundan Ambalaj Kağıdı",
                    description: "Yüksek Mukavemet, Üstün Katlanma Dayanımı, Yüksek Saflık",
                    alt: "Ambalaj Kağıdı"
                },
                culturalPaper: {
                    title: "Saf Bambu Hamurundan Yazı-Baskı Kağıdı",
                    description: "Pürüzsüz Yüzey, Mükemmel Yazma ve Baskı Deneyimi",
                    alt: "Yazı-Baskı Kağıdı"
                },
                livingPaper: {
                    title: "Saf Bambu Hamurundan Tuvalet Kağıdı Hamuru",
                    description: "Islakken Sağlam, Yeşil ve Çevre Dostu",
                    alt: "Tuvalet Kağıdı Hamuru"
                },
                finishedPaper: {
                    title: "Saf Bambu Hamurundan Tuvalet Kağıdı",
                    description: "Yumuşak ve Esnek, Sağlıklı ve Antibakteriyel",
                    alt: "Tuvalet Kağıdı"
                },
                fiberMaterial: {
                    title: "Lif Malzemeleri",
                    description: "Çok Yönlü Özellikler, Farklı Özel İhtiyaçlar İçin Çözüm",
                    alt: "Lif Malzemeleri"
                },
                learnMore: "Daha Fazla Bilgi Edinin"
            }
        },
        about: {
            title: "Yibin Kâğıt Hakkında",
            description1: "Yibin Kâğıt Sanayi A.Ş., 1944 yılında kurulmuş olup Çin'in bambu hamurundan kâğıt üretiminde önde gelen şirketlerindendir. Faaliyetlerimiz bambu hamuru ve kâğıt üretimi üzerine araştırma ve üretime odaklanmaktadır.",
            description2: "Sichuan Eyaleti'nin Yibin şehrinde bulunan şirketimiz, zengin bambu kaynakları ve ileri teknoloji üretim ekipmanlarına sahiptir. Yıllık yüksek kaliteli bambu hamuru kâğıdı üretim kapasitemiz 500.000 tonun üzerindedir.",
            description3: "Teknolojik yenilik ve yeşil üretim yoluyla müşterilerimize üstün kalitede, çevre dostu kâğıt ürünleri sunmayı ve kâğıt endüstrisinin sürdürülebilir gelişimine katkıda bulunmayı taahhüt ediyoruz.",
            learnMore: "Daha Fazla Bilgi Edinin"
        },
        sustainability: {
            title: "Sürdürülebilir Kalkınma",
            subtitle: "Bambu Hamuru ile Kâğıt Üretimi, Yeşil Döngü",
            items: {
                renewable: {
                    title: "Bambu: Yenilenebilir Bir Kaynak",
                    description: "Bambu 3-5 yıl gibi kısa bir sürede olgunlaşıp hasat edilebilir, hızlı büyümesiyle ideal bir yenilenebilir kâğıt hamuru hammaddesidir."
                },
                carbon: {
                    title: "Karbon Yutak Kapasitesi",
                    description: "Bambu ormanları, aynı büyüklükteki diğer ormanlara kıyasla daha fazla CO₂ emerek iklim değişikliğinin etkilerini hafifletmede etkilidir."
                },
                clean: {
                    title: "Temiz Üretim",
                    description: "Kapalı devre üretim süreçleri kullanılmakta; atık sular arıtılarak yeniden değerlendirilmekte, böylece enerji verimliliği sağlanmakta ve emisyonlar azaltılmaktadır."
                },
                rural: {
                    title: "Kırsal Kalkınmaya Destek",
                    description: "Bambu yetiştiricilerinin gelirlerinin artmasına katkıda bulunuyor, yerel ekonomik kalkınmayı destekliyor ve böylece ekolojik ve ekonomik açıdan kazan-kazan durumu sağlıyoruz."
                }
            }
        },
        cta: {
            title: "Bizimle İş Birliği Yapın, Yeşil Bir Gelecek Kuralım",
            description: "Size bambu hamurundan üretilmiş üstün kaliteli kâğıt ürünleri ve profesyonel hizmetler sunmayı dört gözle bekliyoruz.",
            buttonText: "İletişim"
        }
    },
    contact: {
        banner: {
            title: 'İletişim',
            subtitle: 'Sorularınız, görüşleriniz ve geri bildirimleriniz için her zaman buradayız.'
        },
        contactInfo: {
            title: 'İletişim',
            subtitle: 'Sorularınız, görüşleriniz ve geri bildirimleriniz için her zaman buradayız.',
            address: {
                title: 'Adres',
                content: 'Peishi Hafif Sanayi Bölgesi, Nanxi Bölgesi, Yibin Şehri, Sichuan Eyaleti, Çin',
                postcode: 'Posta Kodu: 644100'
            },
            phone: {
                title: 'Telefon',
                main: 'Santral: +86 0831-3309663',
                service: 'Müşteri Hizmetleri: +86 0831-3309698'
            },
            email: {
                title: 'E-posta',
                service: 'Müşteri Hizmetleri: ybzy@yb-zy.com',
                inquiry: 'Ürün Bilgisi: ybzy@yb-zy.com'
            },
            workingHours: {
                title: 'Çalışma Saatleri',
                weekday: 'Pazartesi - Cuma: 9:00 - 17:30',
                holiday: 'Resmi Tatiller Kapalı'
            }
        },
        inquiry: {
            title: 'Çevrimiçi İletişim Formu',
            subtitle: 'Aşağıdaki formu doldurun, sizinle en kısa sürede iletişime geçeceğiz.',
            form: {
                name: 'Adınız Soyadınız',
                company: 'Şirket Adı',
                email: 'E-posta Adresiniz',
                phone: 'Telefon Numaranız',
                subject: 'Konu',
                subjectPlaceholder: 'Lütfen Konu Seçiniz',
                subjects: {
                    product: 'Ürün Bilgisi',
                    price: 'Fiyat Teklifi',
                    technical: 'Teknik Destek',
                    cooperation: 'İş Birliği Görüşmeleri',
                    other: 'Diğer'
                },
                message: 'Mesajınız',
                submit: 'Gönder',
                submitting: 'Gönderiliyor...'
            },
            sales: {
                title: 'Satış',
                domesticRawPaper: 'Yurtiçi Satış (Ham Kağıt)',
                domesticFinishedPaper: 'Yurtiçi Satış (Nihai Ürünler)',
                international: 'Uluslararası Satış',
                email: 'Satış E-posta'
            },
            afterSales: {
                title: 'Satış Sonrası Destek',
                hotlineRawPaper: 'Destek Hattı (Ham Kağıt)',
                hotlineFinishedPaper: 'Destek Hattı (Nihai Ürünler)',
                email: 'Destek E-posta'
            },
            social: {
                title: 'Bizi Takip Edin',
                wechat: 'WeChat',
                weibo: 'Weibo',
                linkedin: 'LinkedIn'
            }
        },
        location: {
            title: 'Konumumuz',
            subtitle: 'Ziyaretiniz Bizi Onurlandırır',
            mapAlt: 'Yibin Kâğıt Sanayi A.Ş. - Konum',
            transport: {
                public: {
                    title: 'Toplu Taşıma',
                    content: 'Otobüs: Nanxi No. 10 Otobüsü (Zhongba Hattı) ile "Yibin Paper Industry" durağında ininiz.'
                },
                driving: {
                    title: 'Özel Araç',
                    content: 'Navigasyon cihazınıza "Yibin Kâğıt Sanayi A.Ş." adresini giriniz. Ziyaretçiler için otopark mevcuttur.'
                },
                airport: {
                    title: 'Havaalanından Ulaşım',
                    content: 'Yibin Wuliangye Havaalanı şirketimize yaklaşık 58 km mesafededir. Havaalanı servis otobüsü veya taksi kullanarak ulaşım sağlayabilirsiniz.'
                }
            }
        },
        offices: {
            title: '全球办事处',
            subtitle: '国际化服务网络',
            china: {
                title: '中国总部',
                flagAlt: '中国国旗',
                address: '四川省宜宾市翠屏区岷江西路159号',
                phone: '电话：0831-12345678'
            },
            usa: {
                title: '北美代表处',
                flagAlt: '美国国旗',
                address: '美国加利福尼亚州洛杉矶市橡树大道2588号',
                phone: '电话：+1-213-888-9999'
            },
            japan: {
                title: '日本代表处',
                flagAlt: '日本国旗',
                address: '日本东京都千代田区丸之内1-2-3',
                phone: '电话：+81-3-1234-5678'
            },
            europe: {
                title: '欧洲代表处',
                flagAlt: '德国国旗',
                address: '德国汉堡市汉萨街456号',
                phone: '电话：+49-40-8765-4321'
            },
            singapore: {
                title: '东南亚代表处',
                flagAlt: '新加坡国旗',
                address: '新加坡莱佛士码头10号',
                phone: '电话：+65-6789-0123'
            }
        },
        faq: {
            title: 'Sık Sorulan Sorular (SSS)',
            subtitle: 'Sorularınıza Hızlı Yanıtlar'
        },
        cta: {
            title: 'Sizinle Tanışmayı Dört Gözle Bekliyoruz',
            description: 'Her türlü soru ve ihtiyacınız için buradayız. Size en iyi şekilde yardımcı olmaya hazırız.',
            buttonText: 'Hemen İletişime Geçin'
        }
    }
} 